import { Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

import { SIDEBAR_LEFT_PADDING_UNITS } from '../sidebarConstants';

interface SidebarGroupHeaderProps {
  groupName: string;
}

export function SidebarGroupHeader({ groupName }: SidebarGroupHeaderProps) {
  return (
    <Typography
      variant="eyebrow-xs"
      component="h2"
      color={COLORS.TEXT.SECONDARY}
      pl={SIDEBAR_LEFT_PADDING_UNITS}
    >
      {groupName}
    </Typography>
  );
}
